import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchWordOfDay } from "../study/vocabulary/vocabularyService";
import "./WordOfDayBanner.css";

const difficultyColor = (d) => ({
  BEGINNER: "#4caf50", ELEMENTARY: "#8bc34a", INTERMEDIATE: "#ff9800",
  UPPER_INTERMEDIATE: "#ff5722", ADVANCED: "#e91e63", EXPERT: "#9c27b0",
}[d?.toUpperCase()] || "#999");

const WordOfDayBanner = () => {
  const [word, setWord] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      const res = await fetchWordOfDay();
      if (res.status === 200 && res.data?.status) {
        setWord(res.data.data);
      }
    };
    load();
  }, []);

  if (!word) return null;

  return (
    <div className="wod-banner" onClick={() => navigate("/study/vocabulary/word-of-day")}>
      <div className="wod-banner-inner">
        <span className="wod-banner-label">📅 Word of the Day</span>
        <div className="wod-banner-content">
          <span className="wod-banner-word">{word.word}</span>
          {word.partOfSpeech && <span className="wod-banner-pos">{word.partOfSpeech}</span>}
          <span className="wod-banner-sep">—</span>
          <span className="wod-banner-meaning">{word.meaning}</span>
          <span className="wod-banner-difficulty" style={{ background: difficultyColor(word.difficulty) }}>
            {word.difficulty?.replace(/_/g, " ")}
          </span>
        </div>
        <span className="wod-banner-arrow">→</span>
      </div>
    </div>
  );
};

export default WordOfDayBanner;
